export default "__VITE_ASSET__CmZy070G__"